import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from "../utils/pcormobile";
import routerH5 from "./routerH5";
import routerPC from "./routerPC";
Vue.use(Router)

//暂时保留，后期做h5端使用
const routes = isMobile() ? routerH5 : routerPC;





export default new Router({
  mode: 'history',
  //暂时保留，后期做h5端使用
  routes: routes
  // routes: [
  //   {
  //     path: '/',
  //     name: 'realTimeMonitoring',
  //     component: () => import('@/views/monitoring/realTimeMonitoring')
  //   },
  //   {
  //     path: '/appRealTime',
  //     name: 'appRealTimeMonitoring',
  //     component: () => import('@/views/monitoring/appRealTimeMonitoring')
  //   },
  //   {
  //     path: '/newRealTime',
  //     name: 'newRealTimeMonitoring',
  //     component: () => import('@/views/monitoring/newRealTimeMonitoring')
  //   },
  // ]
})



// WEBPACK FOOTER //
// ./src/router/index.js